import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { Card } from '../ui/card';
import api from '../../lib/api';
import { money } from '../merchant/attributionApi';

export function PartnerLeaderboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.request('/affiliates/leaderboard').then(setData).catch(() => setData(null)); }, []);
  if (!data) return null;
  const top = data.rows.slice(0, 10);
  return (
    <Card className="p-5" data-testid="partner-leaderboard">
      <h3 className="font-semibold text-sm flex items-center gap-2 mb-3"><Trophy className="w-4 h-4 text-amber-500" /> Partner leaderboard · {data.quarter}</h3>
      {!top.length ? <p className="text-sm text-muted-foreground">No partners yet</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-xs text-muted-foreground text-left"><th className="py-1 pr-2">#</th><th>Partner</th><th className="text-right">Referrals</th><th className="text-right">Approved MIDs</th><th className="text-right">Residuals</th></tr></thead>
            <tbody>
              {top.map((r) => (
                <tr key={r.affiliate_id} className="border-t" data-testid={`leaderboard-row-${r.affiliate_id}`}>
                  <td className="py-2 pr-2 font-semibold">{r.rank}</td>
                  <td><Link to={`/affiliates/${r.affiliate_id}`} className="hover:underline">{r.name}</Link></td>
                  <td className="text-right">{r.referrals}</td>
                  <td className="text-right">{r.approved_mids}</td>
                  <td className="text-right">{money(r.residuals)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
